export default __webpack_public_path__ + "static/wax-d4ff2347fb646094dc8e7cb6feb682cf.png";